const MILLISECONDS_IN_ONE_DAY = 24 * 60 * 60 * 1000;

export const CHAT_OPEN_DELAY = 2000;
export const CHAT_FORCE_OPEN_KEY = 'newbuilding_chat/newbuilding_card/force_open';
export const CHAT_FORCE_OPEN_INTERVAL = MILLISECONDS_IN_ONE_DAY;
